import ErrorBoundary from '~/components/ErrorBoundary'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import ExternalCampaignMetricsPage from './ExternalCampaignMetrics'

const CampaignForm: React.FC = () => {
  const { t } = useAPPTranslation()

  return (
    <ErrorBoundary
      name="ExternalCampaignMetricsPage"
      errorComponentProps={{
        title: t('c:components.ErrorBoundary.title'),
        description: t('c:components.ErrorBoundary.description'),
        tryAgainLabel: t('c:components.ErrorBoundary.tryAgainLabel'),
        errorLabel: t('c:components.ErrorBoundary.errorLabel'),
        fullScreen: false
      }}
    >
      <ExternalCampaignMetricsPage />
    </ErrorBoundary>
  )
}

export default CampaignForm
